var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeHide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a6acb8",
    fillRule: "evenodd",
    transform: "translate(1.5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.782 6.34l-2.839 4.054a10.316 10.316 0 0 0-6.204-2.062c-5.722 0-10.361 4.639-10.361 10.361 0 3.627 1.863 6.818 4.684 8.67l-2.621 3.743C8.785 28.813 4.305 24.626 0 18.544 6.685 8.848 13.883 4 21.595 4c3.093 0 6.155.78 9.187 2.34zm2.081 1.195c3.816 2.424 7.582 6.094 11.3 11.01-6.91 9.76-14.27 14.64-22.082 14.64-2.165 0-4.295-.374-6.39-1.124l2.533-3.618c1.097.396 2.281.612 3.515.612 5.723 0 10.362-4.64 10.362-10.362a10.32 10.32 0 0 0-2.404-6.636l3.166-4.522zM19.396 22.601a4.507 4.507 0 1 1 5.163-7.374l-5.163 7.374zm6.639-5.314a4.507 4.507 0 0 1-4.197 5.994l4.197-5.994z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.816,
    height: 2.946,
    x: -0.702,
    y: 17,
    rx: 1.473,
    transform: "rotate(-55 20.707 18.473)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.db114ba8c9baf2b5e2396bd85f24b384.svg";
export { ForwardRef as ReactComponent };